import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { merge, throwError as _throw } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';

import { DlgNotEnoughAccessKeysComponent } from './dlg-not-enough-access-keys';

@Injectable()
export class ShowDlgNotEnoughAccessKeysService {
    constructor(
        private _dialog: MatDialog,
    ) {
    }

    show(): Promise<any> {
        const dialogRef = this._dialog.open(DlgNotEnoughAccessKeysComponent, {
            panelClass: ['--ui'],
            data: {}
        });

        const source = dialogRef.afterClosed();
        const success$ = source
            .pipe(filter<boolean>((val) => val));
        const error$ = source
            .pipe(filter((val) => !val))
            .pipe(switchMap((error) => _throw(`${ error }`)));

        return merge(success$, error$).toPromise();
    }
}
